/* skip-links-container.tsx generated by @compiled/babel-plugin v0.29.1 */
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */
import "./skip-links-container.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Text } from '@atlaskit/primitives';
import { useSortedSkipLinks } from '../../context/skip-links/skip-links-data-context';
import { SkipLink } from './skip-link';

// TODO (BLU-3215): Fix avoid using ts-ignore
var styles = {
  root: "_18s8v47k _1rjcu2gc _18zr12x7 _kqsw1n9t _1pby1mrw _11q71bhr _2rkoglpi _16qs1cd0 _1e02qkuk _tzy4idpf _t9ec1i34 _1digjh3g _gtjaidpf _1mygkb7n _66dk1kli",
  skipLinkList: "_1x8w11lx _2mzuglyw _1pfh1b66 _bozg1sck"
};

// Correctly typed handler for use with native DOM events
var handleBlur = function handleBlur(event) {
  if (!(event.target instanceof Element)) {
    return;
  }
  event.target.removeAttribute('tabindex');
  event.target.removeEventListener('blur', handleBlur);
};
var escapeHandler = function escapeHandler(event) {
  if (event.key === 'Escape') {
    var activeElement = document.activeElement;
    if (activeElement !== null) {
      activeElement.blur();
    }
  }
};
var attachEscHandler = function attachEscHandler() {
  return window.addEventListener('keydown', escapeHandler, false);
};
var removeEscHandler = function removeEscHandler() {
  return window.removeEventListener('keydown', escapeHandler, false);
};

/**
 * A container element for the skip links
 * The default label will be used when the `skipLinksLabel` attribute is not
 * provided or the attribute is an empty string. If a string comprised only of
 * spaces is provided, the skip link heading element will be removed, but the
 * default label will still be used in `title` attribute of the skip links
 * themselves.
 */
export var SkipLinksContainer = function SkipLinksContainer(_ref) {
  var label = _ref.label;
  var sortedSkipLinks = useSortedSkipLinks();
  if (sortedSkipLinks.length === 0) {
    return null;
  }
  var emptyLabelOverride = !!(label !== null && label !== void 0 && label.match(/^\s+$/));
  return /*#__PURE__*/React.createElement("div", {
    onFocus: attachEscHandler,
    onBlur: removeEscHandler,
    className: ax([styles.root])
  }, emptyLabelOverride ? null : /*#__PURE__*/React.createElement(Text, {
    weight: "medium"
  }, label), /*#__PURE__*/React.createElement("ol", {
    className: ax([styles.skipLinkList])
  }, sortedSkipLinks.map(function (_ref2) {
    var id = _ref2.id,
      label = _ref2.label;
    return /*#__PURE__*/React.createElement(SkipLink, {
      key: id,
      href: "#".concat(id),
      isFocusable: true
    }, label);
  })));
};